import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { createSelector } from 'reselect';
import Global from '../../../../store/global-selectors';
import ActionableFilterPill from '../../index';
import { isOperator } from '../../../../filters/operators/collection';

const getDisplayName = (appliedFilters) => {
  if (appliedFilters.length === 0) {
    return <FormattedMessage defaultMessage='Destination' description='filterOptions.destination' id='x/2Z+s' />;
  }
  const [filter] = appliedFilters;
  if (filter.criterionOperatorValue === isOperator.name) {
    return <FormattedMessage defaultMessage='Domestic' description='filterOptions.destinationDomestic' id='y9VJCS' />;
  }
  return <FormattedMessage defaultMessage='International' description='filterOptions.destinationInternational' id='94roj/' />;
};

const displayContentSelector = createSelector((appliedFilters) => appliedFilters, getDisplayName);

const mapStateToProps = (state, ownProps) => {
  const appliedFilters = Global.selectOrdersFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });
  const displayContent = displayContentSelector(appliedFilters);
  return {
    isSelected: !!appliedFilters.length,
    displayContent,
  };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
